import { render } from "./OmnichannelOverview.vue?vue&type=template&id=40f68026"
import script from "./OmnichannelOverview.vue?vue&type=script&lang=js"
export * from "./OmnichannelOverview.vue?vue&type=script&lang=js"

import "./OmnichannelOverview.vue?vue&type=style&index=0&id=40f68026&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__